(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-customize-ctas"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-ctas')) {
    const touchQuery = window.matchMedia('(hover: none)');
    /** @type {Set<ProductCardCtas>} */
    const visible = new Set();
    /** @type {Set<ProductCardCtas>} */
    let highlighted = new Set();
    let frame = 0;
    let observer;

    // Highlights the card row closest to the middle of the viewport, like a social feed.
    // Cards sharing a row (2-column grid) are highlighted together; the handoff from one row
    // to the next happens in the same frame so one fades out while the next fades in.
    const updateHighlight = () => {
      frame = 0;
      const next = new Set();

      if (touchQuery.matches && visible.size) {
        const center = window.innerHeight / 2;
        const distances = [...visible].map((el) => {
          const rect = el.getBoundingClientRect();
          return { el, distance: Math.abs(rect.top + rect.height / 2 - center) };
        });
        const closest = Math.min(...distances.map(({ distance }) => distance));
        distances.forEach(({ el, distance }) => distance - closest < 4 && next.add(el));
      }

      highlighted.forEach((el) => !next.has(el) && el.deactivate());
      next.forEach((el) => !highlighted.has(el) && el.activate());
      highlighted = next;
    };

    const scheduleUpdate = () => {
      frame ||= requestAnimationFrame(updateHighlight);
    };

    class ProductCardCtas extends HTMLElement {
      connectedCallback() {
        this.card = this.closest('product-card');
        if (!this.card) return;

        if (!observer) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) visible.add(entry.target);
              else visible.delete(entry.target);
            });
            scheduleUpdate();
          });
          window.addEventListener('scroll', scheduleUpdate, { passive: true });
          window.addEventListener('resize', scheduleUpdate, { passive: true });
          touchQuery.addEventListener('change', scheduleUpdate);
        }
        observer.observe(this);
      }

      disconnectedCallback() {
        observer?.unobserve(this);
        visible.delete(this);
        highlighted.delete(this);
      }

      activate() {
        this.setAttribute('active', '');
      }

      deactivate() {
        this.removeAttribute('active');
      }
    }

    customElements.define('product-card-ctas', ProductCardCtas);
  }
  } catch(e) { console.error(e); }
})();

})();
